// extracted by mini-css-extract-plugin
module.exports = {"root":"DynamicPetSitterCount_root__qs9h8"};